import { Group } from "models/profile/Group"
import { makeRequest } from "./networkUtils"

export const getGroups = (): Promise<Group[]> => {
    return makeRequest("groups").then(groups => groups.map(group => Object.assign(new Group(), group)));
}

export const getGroup = (id: string): Promise<Group> => {
    return makeRequest(`groups/${id}`)
}

export const createGroupDO = (group: Group): Promise<Group> => {
    return makeRequest("groups", { method: "POST", body: group })
}

export const saveGroupDO = (group: Group): Promise<Group> => {
    return makeRequest(`groups/${group.id}`, { method: "PUT", body: group })
}

export const deleteGroupDO = (group: Group): Promise<void> => {
    return makeRequest(`groups/${group.id}`, { method: "DELETE" })
}

export const publishGroups = (): Promise<void> => {
    return makeRequest("utils/publish", { method: "POST", body: { type: "groups" } })
}

export const getGroupProfiles = (groupId: string): Promise<any[]> => {
    return makeRequest(`groups/${groupId}/profiles`)
}

export const addProfileToGroup = (groupId: string, profileId: string): Promise<void> => {
    return makeRequest(`groups/${groupId}/profiles/${profileId}`, { method: "POST" })
}

export const removeProfileFromGroup = (groupId: string, profileId: string): Promise<void> => {
    return makeRequest(`groups/${groupId}/profiles/${profileId}`, { method: "DELETE" })
}

export const getProfileGroups = (profileId: string): Promise<Group[]> => {
    return makeRequest(`profiles/${profileId}/groups`)
}